module.exports = __webpack_public_path__ + "images/151_2048.jpg";